<div class="wdc-main">
	<div class="main">
		<p>{{'Warranty Dealer Codes Text1'|translate}}</p>
		<form name="wdcSelectionForm" method="post" action="/servicereception/warrantyDealerCodeSelection.do">
			<input type="hidden" name="org.apache.struts.taglib.html.TOKEN" value="8a751bf04535272a75ead3d314cd9c08">
			<input type="hidden" name="buttonID" value="InitialDisplay">
			<input type="hidden" name="customerPaid" value="false">
			<p>
				{{'Select the applicable Warranty Dealer Code'|translate}}:
				<br>
				<select *ngIf="showSelect" [ngClass]="{ 'dropdown-highlight':isHighlighted}" name="selectedWDC"
					(change)="changeWDC($event)">
					<option selected *ngFor="let li of WDCListSelect;let i = index"
						[attr.selected]="i == 0 ? true : null">{{li.code|uppercase}}-{{li.description}}</option>
				</select>
				<select *ngIf="!showSelect" name="selectedWDC" disabled="disabled">
					<option value="wdcDescriptions">{{'There are no Warranty Dealer Codes added to this
						PTU'|translate}}.</option>
				</select>
			</p>
			<p *ngIf="showSelect">{{'Warranty Dealer Codes Text2'|translate}}</p>
			<input *ngIf="showSelect" style="margin-right: 7px;" type="submit" value="{{'Continue'|translate}}"
				(click)="continue()" class="rateControlled">
			<input type="submit" (click)="continue1()" value="{{'Customer Paid'|translate}}" class="rateControlled">
		</form>
	</div>
	<input style="margin-top:2%" type="submit" (click)="showManage=true"
		value="{{'Manage Warranty Dealer Codes'|translate}}" class="rateControlled">
</div>
<div *ngIf="showManage">
	<app-manage-warranty-dealer-code></app-manage-warranty-dealer-code>
</div>
<div id="overlay" *ngIf="viewRepairQualification">
	<span id="nav-spinner">
		<img src="assets/images/ajax-loader.gif" width="80" height="80">
	</span>
</div>
<ng-template #confirmWDCPopUp let-modal>
	<div class="container version">
		<div class="row popup-header" style="margin-top: 0%;">
			<div class="pull-left">{{'Information'|translate}}</div>
			<div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
					(click)="modal.dismiss('confirmWDCPopUp')"></i></div>
		</div>
		<div>
			<label class='msg-body'>
				<p>
					{{'Confirm_wdc_msg'|translate}} <span class="highlight-wdc-code">{{selectedWDC}}</span> {{'Confirm_wdc1_msg'|translate}}?.
				</p>
			</label>
		</div>
		<hr class="hr-line1">
		<div class="popup-footer">
			<button type="button" class="close-btn-popup pull-right" name="cancel"
				(click)="modal.dismiss('confirmWDCPopUp');confirmWDC()">{{'btn_confirm_wdc'|translate}}</button>
			<button type="button" class="close-btn-popup pull-right" name="cancel"
				(click)="modal.dismiss('confirmWDCPopUp');changeWDCPopUpBtn()">{{'btn_change_wdc'|translate}}</button>
		</div>
	</div>
</ng-template>
<ng-template #customerPaidPopUp let-modal>
	<div class="container version">
		<div class="row popup-header" style="margin-top: 0%;">
			<div class="pull-left">{{'Information'|translate}}</div>
			<div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
					(click)="modal.dismiss('customerPaidPopUp')"></i></div>
		</div>
		<div>
			<label class='msg-body'>
				<p>
					{{'CustomerPaid_Info1'|translate}} <span class="bold-red">{{'CustomerPaid_Info2'|translate}}</span> {{'CustomerPaid_Info3'|translate}}?
				</p>
			</label>
		</div>
		<hr class="hr-line1">
		<div class="popup-footer">
			<button type="button" class="close-btn-popup pull-right" name="cancel"
				(click)="modal.dismiss('customerPaidPopUp');customerPaidPopupBtn()">{{'btn_customer_paid'|translate}}</button>
			<button type="button" class="close-btn-popup pull-right" name="cancel"
				(click)="modal.dismiss('customerPaidPopUp');WarrantyClaimPopupBtn()">{{'btn_Warranty_Claim'|translate}}</button>
		</div>
	</div>
</ng-template>
<ng-template #selectWDC let-modal>
	<div class="container version">
		<div class="row popup-header" style="margin-top: 0%;">
			<div class="pull-left">{{'Information'|translate}}</div>
			<div class="pull-right cross-button" title="close"><i class="fa fa-times" aria-hidden="true"
					(click)="modal.dismiss('selectWDC')"></i></div>
		</div>
		<div>
			<label class='msg-body'>
				<p>
					{{'select_wdc'|translate}}.
				</p>
			</label>
		</div>
		<hr class="hr-line1">
		<div class="popup-footer">
			<button type="button" class="close-btn-popup pull-right" name="cancel"
				(click)="modal.dismiss('selectWDC');selectWDCPopUp()">{{'continue'|translate}}</button>
		</div>
	</div>
</ng-template>